import { IAppState } from '@state/types';
import { IUserAccess } from './types';

export const getUserAccess = (state: IAppState): any | undefined => state.userAccess.userAccesses;
export const getDeletedUserAccess = (state: IAppState):boolean | undefined => state.userAccess.deletedUserAccess;
export const getUserAccessSearch = (state: IAppState): any | undefined => state.userAccess.searches;
export const getPostedUserAccess = (state: IAppState): any | undefined => state.userAccess.response;